import { render, staticRenderFns } from "./seniorThree.vue?vue&type=template&id=21e73799&scoped=true"
import script from "./seniorThree.vue?vue&type=script&lang=js"
export * from "./seniorThree.vue?vue&type=script&lang=js"
import style0 from "./seniorThree.vue?vue&type=style&index=0&id=21e73799&prod&scoped=true&lang=less"
import style1 from "./seniorThree.vue?vue&type=style&index=1&id=21e73799&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21e73799",
  null
  
)

export default component.exports